<template>
    <div class="h-full w-full flex flex-col">
        <TestimonialForm mode="create" @created="$emit('created')" @close="$emit('close')" />
    </div>
</template>

<script>
import TestimonialForm from "./form.vue";
export default {
    name: "testimonial-create",
    emits: ["created", "close"],
    components: { TestimonialForm, },
}
</script>